import React, { useState } from 'react';
import Logo from './Logo';

const NAV_LINKS = [
  ['home',          'Home'],
  ['services',      'Services'],
  ['case-studies',  'Case Studies'],
  ['blog',          'Blog'],
  ['about',         'About'],
  ['how-i-work',    'Pricing'],
  ['contact',       'Contact'],
];

export default function Nav({ currentPage, onNavigate }) {
  const [menuOpen, setMenuOpen] = useState(false);

  const navigate = (page) => {
    onNavigate(page);
    setMenuOpen(false);
  };

  const linkStyle = (page) => ({
    fontSize: '14px',
    fontWeight: currentPage === page ? '600' : '400',
    color: currentPage === page ? 'var(--text-h)' : 'var(--text-m)',
    padding: '8px 14px',
    borderRadius: '4px',
    background: currentPage === page ? 'var(--bg-3)' : 'transparent',
    border: 'none',
    cursor: 'pointer',
    transition: 'all 0.15s',
    fontFamily: "'Segoe UI', system-ui, sans-serif",
  });

  return (
    <nav style={{ position: 'sticky', top: 0, zIndex: 200, background: '#fff', borderBottom: '1px solid var(--border)' }}>
      {/* Top bar */}
      <div className="section-pad" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', height: '64px', paddingLeft: '48px', paddingRight: '48px' }}>
        <div onClick={() => navigate('home')} style={{ cursor: 'pointer' }}>
          <Logo size="sm" variant="light" />
        </div>

        {/* Desktop nav links */}
        <div className="nav-desktop" style={{ display: 'flex', alignItems: 'center', gap: '2px' }}>
          {NAV_LINKS.map(([page, label]) => (
            <button
              key={page}
              onClick={() => navigate(page)}
              style={linkStyle(page)}
              onMouseEnter={e => { if (currentPage !== page) { e.target.style.color = 'var(--text-h)'; e.target.style.background = 'var(--bg-3)'; }}}
              onMouseLeave={e => { if (currentPage !== page) { e.target.style.color = 'var(--text-m)'; e.target.style.background = 'transparent'; }}}
            >
              {label}
            </button>
          ))}
        </div>

        {/* Desktop CTA */}
        <button
          className="nav-desktop"
          onClick={() => navigate('contact')}
          style={{ background: 'var(--ms-blue)', color: '#fff', padding: '8px 20px', borderRadius: '4px', fontSize: '14px', fontWeight: '600', border: 'none', cursor: 'pointer', transition: 'background 0.15s', fontFamily: "'Segoe UI', system-ui, sans-serif" }}
          onMouseEnter={e => e.target.style.background = 'var(--ms-blue-dark)'}
          onMouseLeave={e => e.target.style.background = 'var(--ms-blue)'}
        >
          Get in Touch
        </button>

        {/* Hamburger */}
        <button
          className="nav-hamburger"
          onClick={() => setMenuOpen(o => !o)}
          aria-label="Toggle menu"
          style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '6px', lineHeight: 0 }}
        >
          {menuOpen
            ? <span style={{ fontSize: '22px', lineHeight: 1, color: 'var(--text-h)', display: 'block' }}>✕</span>
            : <svg width="22" height="16" viewBox="0 0 22 16" fill="none" aria-hidden="true">
                <rect y="0"  width="22" height="2" rx="1" fill="var(--text-h)" />
                <rect y="7"  width="22" height="2" rx="1" fill="var(--text-h)" />
                <rect y="14" width="22" height="2" rx="1" fill="var(--text-h)" />
              </svg>
          }
        </button>
      </div>

      {/* Mobile menu */}
      {menuOpen && (
        <div style={{ background: '#fff', borderTop: '1px solid var(--border)', padding: '8px 20px 20px' }}>
          {NAV_LINKS.map(([page, label]) => (
            <button
              key={page}
              onClick={() => navigate(page)}
              style={{ display: 'block', width: '100%', textAlign: 'left', fontSize: '15px', fontWeight: currentPage === page ? '600' : '400', color: currentPage === page ? 'var(--ms-blue)' : 'var(--text-h)', background: 'none', border: 'none', borderBottom: '1px solid var(--border)', padding: '14px 0', cursor: 'pointer', fontFamily: "'Segoe UI', system-ui, sans-serif" }}
            >{label}</button>
          ))}
          <button
            onClick={() => navigate('contact')}
            style={{ display: 'block', width: '100%', background: 'var(--ms-blue)', color: '#fff', padding: '12px', borderRadius: '4px', fontSize: '14px', fontWeight: '600', border: 'none', cursor: 'pointer', marginTop: '16px', fontFamily: "'Segoe UI', system-ui, sans-serif" }}
          >
            Get in Touch
          </button>
        </div>
      )}
    </nav>
  );
}
